var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgChangeTheme = function SvgChangeTheme(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e91e63",
    d: "M24,4v20L14,6.681L24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff5722",
    d: "M34,6.681L41.319,14L24,24L34,6.681z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f44336",
    d: "M24,4l10,2.681L24,24V4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#8bc34a",
    d: "M24,44V24l10,17.319L24,44z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#03a9f4",
    d: "M14,41.319L6.681,34L24,24L14,41.319z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#4caf50",
    d: "M24,44l-10-2.681L24,24V44z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff9800",
    d: "M44,24H24l17.319-10L44,24z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffeb3b",
    d: "M41.319,34L34,41.319L24,24L41.319,34z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffc107",
    d: "M44,24l-2.681,10L24,24H44z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#3f51b5",
    d: "M4,24h20L6.681,34L4,24z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#9c27b0",
    d: "M6.681,14L14,6.681L24,24L6.681,14z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#673ab7",
    d: "M4,24l2.681-10L24,24H4z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgChangeTheme, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/change_theme.e0ca3aeb.svg";
export { ForwardRef as ReactComponent };